import { createContext, useContext, useState, useEffect } from 'react';

const TopBarConfigContext = createContext(null);
const TopBarSetterContext = createContext(() => {});

export function TopBarProvider({ children }) {
  const [config, setConfig] = useState(null);
  return (
    <TopBarSetterContext.Provider value={setConfig}>
      <TopBarConfigContext.Provider value={config}>
        {children}
      </TopBarConfigContext.Provider>
    </TopBarSetterContext.Provider>
  );
}

export function useTopBarConfig() {
  return useContext(TopBarConfigContext);
}

export function useTopBar(cfg, deps = []) {
  const setConfig = useContext(TopBarSetterContext);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setConfig(cfg);
  }, deps);
  useEffect(() => {
    return () => setConfig(null);
  }, [setConfig]);
}
